import React from "react";
import CurrencyManageTable from "./currencyList/CurrencyList";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const CurrencyManagement = () => {
  
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <CurrencyManageTable/>
      </div>
    </div>
  );
};

export default CurrencyManagement;
